import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=9daf5b54&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./alert.vue?vue&type=style&index=0&id=9daf5b54&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9daf5b54",
  "2b8caee0"
  
)

export default component.exports